module.exports = __webpack_public_path__ + "e35ad55db9d2f6311303d472c5326773.svg";